import { motion } from "framer-motion";

const EASE = [0.83, 0, 0.17, 1];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-plum py-28 md:py-40"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        {/* Label column */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
          className="md:col-span-3"
        >
          <div className="flex items-center gap-3 text-gold text-[11px] tracking-[0.35em] uppercase">
            <span className="w-8 h-px bg-gold" />
            The Philosophy
          </div>
          <p className="mt-6 text-cream/50 text-sm tracking-[0.1em] uppercase">
            Chapter · 01
          </p>
        </motion.div>

        {/* Quote column */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, ease: EASE, delay: 0.15 }}
          className="md:col-span-9"
        >
          <h2 className="font-serif font-light text-cream text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
            Property is about more than{" "}
            <span className="italic text-gold/90">buildings.</span>
            <br />
            The strongest opportunities are{" "}
            <span className="italic text-cream/70">created through</span>{" "}
            <span className="italic text-gold">relationships.</span>
          </h2>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 max-w-4xl">
            <p className="text-cream/70 text-base md:text-lg leading-relaxed">
              I work across the intersection of property, buyer's advocacy and
              disability housing, helping investors, developers, providers
              and industry professionals design ethical, sustainable and
              future-focused housing solutions.
            </p>
            <p className="text-cream/70 text-base md:text-lg leading-relaxed">
              My approach is quiet, considered and long-term. Every
              introduction, every project and every partnership is chosen with
              intention, because the best outcomes are built on trust.
            </p>
          </div>

          <div className="gold-divider mt-16 max-w-4xl" />
        </motion.div>
      </div>
    </section>
  );
}
